import './BannerSection.css';

const BannerSection = ({ variant = '1', children }) => {
  return (
    <section className={`banner-${variant}`}>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="info-banner text-center">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
